import React from "react";
import { Router, Switch, Route, Redirect } from "react-router-dom";

// routes
import UnRestrictedRoute from "./unRestrictedRoute";
import RestrictedRoute from "./restrictedRoute";


export default ({ history, user }) => {
    return (
        <Router history={history}>
            <Switch>
                {
                    [
                        ...UnRestrictedRoute,
                        ...RestrictedRoute
                    ]
                }
                <Route path="">
                    <Redirect
                        to={{
                            pathname: "/login",
                        }}
                    />
                </Route>
            </Switch>

        </Router>
    );
};